// en, de, fr, pt
export default {
  en: {
    Dashboard: 'Dashboard',

    InputData: 'Entry Data',
    Accounts: 'Accounts Number',
    JournalVoucher: 'Journal Voucher',
    ReportSetting: 'Report Setting',

    ViewPrint: 'View / Print',
    GeneralLedger: 'General Ledger',
    FinancialReport: 'Finansial Statement',
    IncomeReport: 'Income Statement',

    Other: 'Others',
    SettingAccount: 'Account Settings',
    ChangePassword: 'Change Password',

    TabularView: 'Tabular View',
    HeaderView: 'Header View',

    Date: 'Date',
    Description: 'Description',
    Items: 'Items',
    VoucherNumber: 'Voucher Number',

    AccountCode: 'Account Code',
    AccountName: 'Account Name',
    Debit: 'Debit',
    Credit: 'Credit',
    Difference: 'Difference',
    InitBalance: 'Init Balance',
    FinalBalance: 'Final Balance',
    Actions: 'Actions',
    Delete: 'Delete',
    DeleteNotes: 'Are you sure want to permanently delete',
    DeleteSuccess: 'Data has been deleted',
    Success: 'Success',
    Warning: 'Warning',

    StartDate: 'Start Date',
    EndDate: 'End Date',

    DateRange: 'Date Range',
    SearchData: 'Search Data',
    SearchNotes: 'Insert a keyword',
    AddNewData: 'Add New Data',
    AddNewReport: 'Add Report',
    PrintData: 'Print Data',
    SaveData: 'Save Data',
    Apply: 'Apply',
    Save: 'Save',
    Cancel: 'Cancel'
  },
  id: {
    Dashboard: 'Beranda',

    InputData: 'Input Data',
    Accounts: 'Nomor Akun',
    JournalVoucher: 'Voucher Jurnal',
    ReportSetting: 'Atur Laporan',

    ViewPrint: 'Lihat / Print',
    GeneralLedger: 'Buku Besar',
    FinancialReport: 'Laporan Finansial',
    IncomeReport: 'Laporan Laba Rugi',

    Other: 'Lainnya',
    SettingAccount: 'Pengaturan Akun',
    ChangePassword: 'Ganti Kata Sandi',

    TabularView: 'Tampilan Tabel',
    HeaderView: 'Tampilan Tajuk',

    Date: 'Tanggal',
    Description: 'Deskripsi',
    Items: 'Item',
    VoucherNumber: 'Nomor Voucher',

    AccountCode: 'Kode Akun',
    AccountName: 'Nama Akun',
    Debit: 'Debet',
    Credit: 'Kredit',
    Difference: 'Selisih',
    InitBalance: 'Saldo Awal',
    FinalBalance: 'Saldo Akhir',
    Actions: 'Aksi',
    Delete: 'Hapus',
    DeleteNotes: 'Apakah kamu yakin akan menghapus secara permanen',
    DeleteSuccess: 'Data Berhasil dihapus',
    Success: 'Berhasil',
    Warning: 'Perhatian',

    StartDate: 'Tanggal Awal',
    EndDate: 'Tanggal Akhir',

    DateRange: 'Rentang Tanggal',
    SearchData: 'Cari Data',
    SearchNotes: 'Masukkan Kata Kunci',
    AddNewData: 'Tambah Data',
    PrintData: 'Print Data',
    SaveData: 'Simpan Data',
    Apply: 'Terapkan',
    Save: 'Simpan',
    Cancel: 'Batal',

    AddNewReport: 'Tambah Laporan',
    ReportName: 'Nama Laporan',
    SelectAccount: 'Pilih Akun',
    Level1: 'Level 1',
    ViewResult: 'Tampilan Hasil',
    TitleReport: 'Judul Laporan',
    NameAccount: 'Nama Akun'
  }
}
